import { graphql, useStaticQuery } from 'gatsby';

import Img from 'gatsby-image';
import React from 'react';

// Responsive, blur-up image for a photo in src/assets/thumbnail, looked up by file name
const Image = ({ file, alt, className = null, ...rest }) => {
  const { allFile } = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          sourceInstanceName: { eq: "photos" }
          relativePath: {
            in: ["hvik_pabbi_1.jpg", "hvik_pabbi_2.jpg", "hvik_tommi_1.jpg", "hvik_tommi_2.jpg", "hvik_tommi_8.jpg"]
          }
        }
      ) {
        nodes {
          relativePath
          childImageSharp {
            fluid(maxWidth: 1920, quality: 80) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  `);

  const node = allFile.nodes.find(n => n.relativePath === file);

  return <Img className={className} fluid={node.childImageSharp.fluid} alt={alt} {...rest} />;
};

export default Image;
